import React from 'react';
import { IconButton, CircularProgress, SxProps, Theme } from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as UnownedIcon,
} from '@mui/icons-material';
import AuthGuard from '../common/AuthGuard';

interface CardOwnershipToggleProps {
  isOwned: boolean;
  onToggle: () => void;
  isLoading?: boolean;
  sx?: SxProps<Theme>;
}

const CardOwnershipToggle: React.FC<CardOwnershipToggleProps> = ({
  isOwned,
  onToggle,
  isLoading = false,
  sx,
}) => {
  return (
    <AuthGuard>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        disabled={isLoading}
        sx={{
          bgcolor: 'rgba(255,255,255,0.9)',
          '&:hover': { bgcolor: 'rgba(255,255,255,1)' },
          transition: 'all 0.2s',
          ...sx,
        }}
      >
        {isLoading ? (
          <CircularProgress size={20} color="inherit" />
        ) : isOwned ? (
          <CheckCircleIcon color="success" />
        ) : (
          <UnownedIcon color="action" />
        )}
      </IconButton>
    </AuthGuard>
  );
};

export default CardOwnershipToggle;
